import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { ModalSkeleton, queryClient } from '@buildable-microservices/components';
import { ChakraProvider } from '@chakra-ui/react';
import * as FullStory from '@fullstory/browser';
import 'inter-ui/inter.css';
import React, { useEffect } from 'react';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Hydrate } from 'react-query/hydration';
import BuilderContextProvider from '../context/BuilderContext';
import theme from '../styles/theme';
import './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var App = function App(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps;
  useEffect(function () {
    FullStory.init({
      orgId: 'ZZ4H5',
      namespace: 'FS'
    });
  }, []);
  return /*#__PURE__*/_jsx(QueryClientProvider, {
    client: queryClient,
    children: /*#__PURE__*/_jsxs(Hydrate, {
      state: pageProps.dehydratedState,
      children: [/*#__PURE__*/_jsx(ReactQueryDevtools, {
        initialIsOpen: false
      }), /*#__PURE__*/_jsx(ChakraProvider, {
        theme: theme,
        children: /*#__PURE__*/_jsxs(BuilderContextProvider, {
          children: [/*#__PURE__*/_jsx(ModalSkeleton, {}), /*#__PURE__*/_jsx(Component, _objectSpread({}, pageProps))]
        })
      })]
    })
  });
};

export default App;